import {
  RUN_SCHEDULES_LOADING,
  FETCH_RUN_SCHEDULES,
  CREATE_RUN_SCHEDULE,
  UPDATE_RUN_SCHEDULE,
  DELETE_RUN_SCHEDULE,
} from '../actions/runSchedules';

export default function(state = {}, action) {
  switch (action.type) {
    case FETCH_RUN_SCHEDULES:
      return {
        ...state,
        runSchedules: action.payload,
      };
    case RUN_SCHEDULES_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };
    case CREATE_RUN_SCHEDULE:
    case DELETE_RUN_SCHEDULE:
    case UPDATE_RUN_SCHEDULE:
    default:
      return state;
  }
}
